import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dynamicLinkListPageComponent from './dynamicLinkListPage.component';

let dynamicLinkListPageModule = angular.module('dynamicLinkListPage', [
  uiRouter
])

.component('dynamicLinkListPage', dynamicLinkListPageComponent)

.name;

export default dynamicLinkListPageModule;
